import { useContext, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { AppContext } from '../util/AppContext';
import { getConfigValue } from '../util/getConfigValue';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Mustache from 'mustache';

BrandsModal.propTypes = {
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    onBrandClick: PropTypes.func.isRequired,
    isValid: PropTypes.func.isRequired,
    onOverwriteClick: PropTypes.func.isRequired,
    hasPendingChange: PropTypes.bool.isRequired,
};

export function BrandsModal({ show, setShow, onBrandClick, isValid, onOverwriteClick, hasPendingChange }) {
    const [appState] = useContext(AppContext);
    let products = [{ id: null, name: getConfigValue(appState?.config?.AnnouncementManagement?.Announcement?.AllBrands, appState)?.Value, image: null, clientProductId: null }, ...appState?.productDetails || []];
    const [showAlert, setShowAlert] = useState(false);
    const [showConfirmationAlert, setShowConfirmationAlert] = useState(false);
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [selectedBrandMessage, setSelectedBrandMessage] = useState('');

    const navigate = useNavigate();

    function onSelectedBrand(product) {
        // determine if the validaiton
        let message = getConfigValue(appState.config?.AnnouncementManagement?.BrandSelection?.AnnouncementExists?.Body?.Label, appState)?.Value;
        setSelectedBrandMessage(Mustache.render(message, product));

        if (!isValid(product)) {
            setSelectedBrand(product);
            setShowAlert(true);  
            return;
        }

        onBrandClick(product);
        setShowAlert(false);
        setShowConfirmationAlert(false);
    }

    function overwriteAnnouncement(product) {
        onOverwriteClick(product);
        setShowAlert(false);
        setShowConfirmationAlert(false);
    }

    function gotoAnnouncementManagement() {
        navigate("/AnnouncementManagementPage");
    }

    function onViewExistingClick() {
        setShowAlert(false);

        if (hasPendingChange) {
            setShowConfirmationAlert(true);
            return;
        }

        gotoAnnouncementManagement();
    }


    return (
        <Modal show={show} onHide={() => { setShow(false); setShowAlert(false); setShowConfirmationAlert(false); }} scrollable>
            <Modal.Header className="primary" closeButton>
                <Modal.Title className="type-18">{getConfigValue(appState.config?.ProductModal?.SelectBrand?.Label, appState)?.Value || null}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='bg-body-secondary'>
                {showAlert &&
                    <div className={` row alert alert-secondary bg-body-secondary`} role="alert" style={{ borderTop: 'none', boxShadow: 'none'}}>
                        <div className='col-1 border-start border-secondary wide-left-border-5'>
                            <div className="alert-icon"></div>
                        </div>
                        <div className='col-10' style={{ marginLeft: '4%' }}>
                            <div className="alert-content">
                                <h4 className="h5 alert-heading">{getConfigValue(appState.config?.AnnouncementManagement?.BrandSelection?.AnnouncementExists?.Header?.Label, appState)?.Value}</h4>
                                <p>{selectedBrandMessage}</p>
                            </div>

                            <div className="d-grid gap-2 py-3">
                                <button onClick={() => overwriteAnnouncement(selectedBrand)} className="btn btn-primary d-block w-100 text-center py-3" type="button">{getConfigValue(appState.config?.AnnouncementManagement?.BrandSelection?.AnnouncementExists?.OverwriteButton?.Label, appState)?.Value}</button>
                                <button onClick={() => onViewExistingClick()} className="btn btn-primary d-block w-100 text-center py-3" type="button">{getConfigValue(appState.config?.AnnouncementManagement?.BrandSelection?.AnnouncementExists?.ViewExistingButton?.Label, appState)?.Value}</button>
                            </div>
                        </div>
                    </div>
                }

                {showConfirmationAlert &&
                    <div className={` row alert alert-secondary`} role="alert">
                        <div className='col-1'>
                            <div className="alert-icon"></div>
                        </div>

                        <div className='col-10 border-start border-secondary' style={{ marginLeft: '4%' }}>
                            <div className="alert-content">
                                <h4 className="h5 alert-heading">{getConfigValue(appState.config?.AnnouncementManagement?.BrandSelection?.OverwriteWarning?.Header?.Label, appState)?.Value}</h4>
                                <p>{getConfigValue(appState.config?.AnnouncementManagement?.BrandSelection?.OverwriteWarning?.Body?.Label, appState)?.Value}</p>
                            </div>

                            <div className="d-grid gap-2 py-3">
                                <button onClick={() => { setShowConfirmationAlert(false); setShow(false);}}  className="btn btn-secondary d-block w-100 text-center py-3" type="button">{getConfigValue(appState.config?.Common?.Back, appState)?.Value}</button>
                                <button onClick={() => gotoAnnouncementManagement()} className="btn btn-primary d-block w-100 text-center py-3" type="button">{getConfigValue(appState.config?.Common?.Continue, appState)?.Value}</button>
                            </div>
                        </div>
                    </div>
                }


                {!(showAlert || showConfirmationAlert) &&
                    <>
                        <h2 className="type-20 type-bold mb-3">{getConfigValue(appState.config?.ProductModal?.SelectBrand?.Label, appState)?.Value || "Select a Brand"}</h2>

                        <ul className="list-group list-group-flush">
                            {products?.map((product, index) => (
                                <li key={product.id} className="list-group-item border border-0">
                                    <button onClick={() => onSelectedBrand(product)} className="btn btn-tile btn-tile-outline d-block w-100 text-center py-3">
                                        {product.image ? (
                                            <img style={{ 'maxWidth': '100%' }} src={product.image} className="" alt={`${product.name} logo`} />
                                        ) : (
                                            <span>{product.name}</span>
                                        )}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </>
                }
            </Modal.Body>
        </Modal>
    );
}